import { useState } from 'react';
import { useForgotPasswordInfrastructure } from '../infrastructure/hook/useForgotPasswordInfrastructure';

export const useForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const { sendResetEmail } = useForgotPasswordInfrastructure();

    const handleSendPasswordResetEmail = async (emailInput: string) => {
        setLoading(true);
        setError(null);
        setSuccess(false);

        try {
            await sendResetEmail(emailInput);
            setSuccess(true);
            setEmail('');
        } catch (err: any) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const clearError = () => setError(null);

    return {
        handleSendPasswordResetEmail,
        email,
        setEmail,
        loading,
        success,
        error,
        clearError
    };
};
